module.exports = "/images/a03677e37c31a14c823afa622c827524.svg";